"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const TypeUtils_1 = require("../../../common/TypeParsing/TypeUtils");
const styled_components_1 = __importDefault(require("styled-components"));
const Layout_1 = require("./Layout");
const ITEM_PLACEHOLDER = {};
const DeleteButton = styled_components_1.default.button `
  background-color: #a41e1e;
`;
const SelectItemButtonBase = styled_components_1.default.button `
  flex: 0 0 auto;
  width: revert;
`;
const SelectItemButton = ({ index, onSelectItem, children, }) => {
    const onOpenItemInternal = (0, react_1.useCallback)(() => {
        onSelectItem(index);
    }, [index, onSelectItem]);
    return ((0, jsx_runtime_1.jsx)(SelectItemButtonBase, { onClick: onOpenItemInternal, children: children }));
};
const SelectItemCheckbox = ({ index, onSelectItem, selected = false, }) => {
    const onOpenItemInternal = (0, react_1.useCallback)(() => {
        onSelectItem(index);
    }, [index, onSelectItem]);
    return ((0, jsx_runtime_1.jsx)("label", { children: (0, jsx_runtime_1.jsx)("input", { type: "checkbox", checked: selected, onChange: onOpenItemInternal }) }));
};
const ItemBase = styled_components_1.default.div `
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: center;
  gap: 1em;
  max-width: 100%;
`;
const ItemLabelBase = styled_components_1.default.div `
  flex: 1 1 auto;
  gap: 1em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 3em;
  padding: 1em 0;
  box-sizing: border-box;
`;
const List = ({ typeStructure, typeStructureMap, items = [], onChange, onNavigateToPath, onNavigateBack, }) => {
    const [selectedIndices, setSelectedIndices] = (0, react_1.useState)([]);
    const [tryingToDeleteSelectedItems, setTryingToDeleteSelectedItems] = (0, react_1.useState)(false);
    const onBegineDelete = (0, react_1.useCallback)(() => {
        setTryingToDeleteSelectedItems(true);
    }, [setTryingToDeleteSelectedItems]);
    const [itemsAreMoving, setItemsAreMoving] = (0, react_1.useState)(false);
    const getItemLabel = (0, react_1.useCallback)((item, index) => ((0, TypeUtils_1.getValueLabel)(item, typeStructure, typeStructureMap) || "").trim() ||
        `${index + 1}`, [typeStructure, typeStructureMap, items]);
    const onChangeInternal = (0, react_1.useCallback)((value) => {
        if (onChange) {
            onChange(value);
        }
    }, [onChange]);
    const onCancelDelete = (0, react_1.useCallback)(() => {
        setTryingToDeleteSelectedItems(false);
    }, [setTryingToDeleteSelectedItems]);
    const onConfirmDelete = (0, react_1.useCallback)(() => {
        const newItems = items.filter((_, index) => !selectedIndices.includes(index));
        onChangeInternal(newItems);
        setTryingToDeleteSelectedItems(false);
        setSelectedIndices([]);
    }, [
        items,
        onChangeInternal,
        selectedIndices,
        setTryingToDeleteSelectedItems,
        setSelectedIndices,
    ]);
    const onAddItem = (0, react_1.useCallback)(() => {
        onChangeInternal([...items, (0, TypeUtils_1.getDefaultItemForTypeStructure)(typeStructure)]);
    }, [items, onChangeInternal, typeStructure]);
    const onOpenItem = (0, react_1.useCallback)((index) => {
        if (onNavigateToPath) {
            const item = items === null || items === void 0 ? void 0 : items[index];
            onNavigateToPath({
                label: getItemLabel(item, index),
                path: [index],
                isListItem: true,
            });
        }
    }, [onNavigateToPath, items, getItemLabel]);
    const onToggleItemSelected = (0, react_1.useCallback)((index) => {
        if (selectedIndices.includes(index)) {
            setSelectedIndices(selectedIndices.filter((ind) => ind !== index));
        }
        else {
            setSelectedIndices([...selectedIndices, index]);
        }
    }, [selectedIndices, setSelectedIndices]);
    const onSetItemsAreMoving = (0, react_1.useCallback)(() => {
        setItemsAreMoving(true);
    }, [setItemsAreMoving]);
    const onCleanupMovingItems = (0, react_1.useCallback)(() => {
        setItemsAreMoving(false);
        setSelectedIndices([]);
    }, [setItemsAreMoving, setSelectedIndices]);
    const onMoveItems = (0, react_1.useCallback)((moveItemsToIndex) => {
        const newItems = [...items, ITEM_PLACEHOLDER]
            .reduce((acc, itm, ind) => {
            if (selectedIndices.includes(ind)) {
                return [...acc, ITEM_PLACEHOLDER];
            }
            if (ind === moveItemsToIndex) {
                return [...acc, ...selectedIndices.map((i) => items[i]), itm];
            }
            return [...acc, itm];
        }, [])
            .filter((i) => i !== ITEM_PLACEHOLDER);
        onChangeInternal(newItems);
        onCleanupMovingItems();
    }, [items, onChangeInternal, onCleanupMovingItems, selectedIndices]);
    const onSelectAllItems = (0, react_1.useCallback)(() => {
        setSelectedIndices(items.map((_, index) => index));
    }, [items, setSelectedIndices]);
    const onDeselectAllItems = (0, react_1.useCallback)(() => {
        setSelectedIndices([]);
    }, [setSelectedIndices]);
    return ((0, jsx_runtime_1.jsxs)(Layout_1.LayoutBox, { "$allowShrink": true, children: [(0, jsx_runtime_1.jsx)(Layout_1.LayoutBox, { "$allowShrink": true, children: items.map((item, index) => {
                    return itemsAreMoving &&
                        selectedIndices.includes(index) ? undefined : ((0, jsx_runtime_1.jsxs)(ItemBase, { children: [itemsAreMoving ? ((0, jsx_runtime_1.jsx)(SelectItemButton, { index: index, onSelectItem: onMoveItems, children: "Move Here" })) : ((0, jsx_runtime_1.jsx)(SelectItemCheckbox, { index: index, onSelectItem: onToggleItemSelected, selected: selectedIndices.includes(index) })), (0, jsx_runtime_1.jsx)(ItemLabelBase, { children: getItemLabel(item, index) }), (0, jsx_runtime_1.jsx)(SelectItemButton, { index: index, onSelectItem: onOpenItem, children: "Open" })] }, index));
                }) }), (0, jsx_runtime_1.jsxs)(Layout_1.LayoutControls, { children: [selectedIndices.length > 0 ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: itemsAreMoving ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SelectItemButton, { index: items.length, onSelectItem: onMoveItems, children: "Move Here" }), (0, jsx_runtime_1.jsx)("button", { onClick: onCleanupMovingItems, children: "Cancel" })] })) : tryingToDeleteSelectedItems ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("button", { onClick: onCancelDelete, children: "Cancel Delete" }), (0, jsx_runtime_1.jsx)(DeleteButton, { onClick: onConfirmDelete, children: "Confirm Delete" })] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("button", { onClick: onDeselectAllItems, children: "Deselect All" }), (0, jsx_runtime_1.jsx)("button", { onClick: onSetItemsAreMoving, children: "Move Item(s)" }), (0, jsx_runtime_1.jsx)("button", { onClick: onBegineDelete, children: "Delete Item(s)" })] })) })) : undefined, itemsAreMoving ? undefined : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [selectedIndices.length < items.length ? ((0, jsx_runtime_1.jsx)("button", { onClick: onSelectAllItems, children: "Select All" })) : undefined, (0, jsx_runtime_1.jsx)("button", { onClick: onAddItem, children: "+ Add Item" }), (0, jsx_runtime_1.jsx)("button", { onClick: onNavigateBack, children: "Done" })] }))] })] }));
};
exports.List = List;
